import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Heart, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useSearch } from "@/context/SearchContext";
import { VenueCard } from "@/components/VenueCard";
import { haversine } from "@/lib/hh";
import { AlertsToggle } from "@/components/AlertsToggle";

export default function Saved() {
  const { user } = useAuth();
  const { origin } = useSearch();
  const [venues, setVenues] = useState(null);
  const savedKey = (user && user.saved?.join(",")) || "";
  useEffect(() => {
    if (user) api.get("/me/saved").then((r) => setVenues(r.data)).catch(() => setVenues([]));
  }, [user, savedKey]);
  if (user === false) return <Navigate to="/login?next=/saved" replace />;
  const list = (venues || []).filter((v) => user?.saved?.includes(v.id)).map((v) => ({
    ...v, distance: origin && v.lat != null ? Number(haversine(origin, v).toFixed(1)) : null,
  }));
  return (
    <div className="page">
      <p className="eyebrow">Your favorites</p>
      <h1 className="font-heading mt-2 text-5xl text-white sm:text-6xl">Saved Spots</h1>
      <AlertsToggle />
      {venues === null ? (
        <Loader2 className="mt-10 animate-spin text-[#fde68a]" />
      ) : !list.length ? (
        <div data-testid="saved-empty" className="panel mt-8 flex flex-col items-start gap-3 p-8">
          <Heart className="text-rose-400" />
          <p className="text-zinc-300">No saved spots yet. Tap the heart on any venue to keep it here.</p>
          <Link to="/" className="font-semibold text-[#fde68a] hover:underline">Find happy hours →</Link>
        </div>
      ) : (
        <div data-testid="saved-list" className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {list.map((v) => <VenueCard key={v.id} venue={v} />)}
        </div>
      )}
    </div>
  );
}
